'use client'
import { useState } from 'react'
import { SectionAccordion } from '@fitro/customer-ui/SectionAccordion'
import type { PublicScheduleEvent } from '../../../services/public-schedule.service'
import { useTranslation } from '../../../hooks/useTranslation'
import { formatPriceMinor } from '../../../lib/formatPriceMinor'
import { publicEventPrice, reductionPercent } from './publicEventPrice'

/** The promotion behind a reduced price and the first-booking offer, collapsed so the price stays short. */
export function PublicScheduleEntryPromotions({ event }: { event: PublicScheduleEvent }) {
    const { t, locale } = useTranslation('landing')
    const [open, setOpen] = useState(false)
    const price = publicEventPrice(event)
    const promotionName = event.guestCheckoutPrice ? event.guestCheckoutPrice.promotionName : event.automaticPromotion?.name
    const promotion = price?.kind === 'paid' && price.lowestPrice30dMinor !== null && promotionName
        ? `${promotionName} −${reductionPercent(price.amountMinor, price.lowestPrice30dMinor)}%`
        : null
    const firstEntry = price?.kind === 'paid' && price.firstEntryMinor !== null
        ? formatPriceMinor(price.firstEntryMinor, price.currency, locale)
        : null
    const firstPurchase = Boolean(firstEntry || event.firstPurchaseDiscountAvailable)
    if (!promotion && !firstPurchase) return null
    const summary = [promotion, firstEntry ? t('publicEntry.events.firstEntry', {amount: firstEntry}) : firstPurchase ? t('publicEntry.details.firstPurchaseShort') : null].filter(Boolean).join(' · ')
    return (
        <SectionAccordion variant="row" title={t('publicEntry.details.promotions')} description={summary} isOpen={open} onToggle={() => setOpen(value => !value)}>
            <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-gray-600 dark:text-gray-300">
                {promotion ? <li>{promotion}</li> : null}
                {firstPurchase ? <li>{firstEntry ? t('publicEntry.details.firstEntryDetails', {amount: firstEntry}) : t('publicEntry.details.firstPurchaseDetails')}</li> : null}
            </ul>
        </SectionAccordion>
    )
}
